import React, { useEffect, useRef, useState } from "react";
import { NavigationItem } from "../../@types/Navigation";
import "./navigation.css";
import { StaticImage } from "gatsby-plugin-image";

interface NavigationI {
    items: NavigationItem[];
}

const Navigation:React.FC<NavigationI> = ({ items }) => {

    const [mobileScreen, setMobileScreen] = useState<boolean>(false);
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const menuRef = useRef<HTMLUListElement | null>(null); 

    const onResize=()=>{
        if(window.innerWidth < 760){
            setMobileScreen(true);
        } else {
            if(menuOpen) setMenuOpen(false);
            setMobileScreen(false);
        }
    }

    const onDocumentClick = (e:MouseEvent) =>{
        if(menuOpen && menuRef.current){
            if(menuRef.current.contains(e.target as Node)) {
                setMenuOpen(false);
                document.removeEventListener("click", onDocumentClick);  
            }
        }
    }
    
    useEffect(()=>{
        if(window.innerWidth < 760) setMobileScreen(true);
        window.addEventListener("resize",onResize);
        return ()=>{
            window.removeEventListener("resize", onResize);
        }
    },[])

    useEffect(()=>{
        if(menuOpen){
            document.addEventListener("click", onDocumentClick);
            return ()=>{
                document.removeEventListener("click", onDocumentClick);
            }
        }
    },[menuOpen])

    return(
        <nav id="main-nav" className="main-menu">
            { mobileScreen ? (
                <div className="mobile-menu flex">
                    <div className={"cursor-pointer flex items-center"} onClick={()=>setMenuOpen(true)}>
                        <StaticImage 
                        height={24}
                        width={24}
                        src="../../images/icon-menu.svg" 
                        alt="icon-menu" />
                    </div>

                    <ul className={menuOpen ? "open" : undefined} ref={menuRef}>
                    {items.map((item, index)=>(
                        <a href={item.uri} key={item.uri + index} onClick={()=>setMenuOpen(false)}>
                            <li key={item.uri+index} style={{width:"100%", padding:"8px 32px"}}>{item.label}</li>
                        </a>
                    ))}
                    </ul>
                </div>
            ) : (
            <ul className="">
                {items.map((item, index)=>(
                    <a href={item.uri} key={item.uri + index}>
                        <li key={item.uri+index}>{item.label}</li>
                    </a>
                ))}
            </ul>
            )}
        </nav>
    )
}

export default Navigation;